import { Blog } from "models/blog.model";
import { News } from "models/news.model";
import { Faq } from "models/faq.model";
import { Link } from "models/link.model";
import { File } from "models/file.model";
import omit from "lodash/omit";
const config = useRuntimeConfig();
export const blog = {
  useGetBlog: createUseApi<string, Blog>({
    method: "GET",
    url: `${config.public.url}/blog`,
    queryBuilder(inputData) {
      return {
        locale: inputData === "uk" ? "ua" : inputData,
      };
    },
  }),

  useCreateNews: createUseApi<News, void>({
    method: "POST",
    url: `${config.public.url}/blog/news`,
    dataBuilder: (inputData) => omit(inputData, "id"),
    requireAuthentication: true,
  }),

  useGetOneNews: createUseApi<string, News>({
    method: "GET",
    url: (input) => `${config.public.url}/blog/news/${input}`,
    requireAuthentication: true,
  }),

  useGetNewsArticleBySlug: createUseApi<string, News>({
    method: "GET",
    url: (input) => `${config.public.url}/blog/news/slug/${input}`,
  }),

  useUpdateNews: createUseApi<News, void>({
    method: "PATCH",
    url: (input) => `${config.public.url}/blog/news/${input.id}`,
    dataBuilder: (inputData) => inputData,
    requireAuthentication: true,
  }),

  useDeleteNews: createUseApi<string, void>({
    method: "DELETE",
    url: (input) => `${config.public.url}/blog/news/${input}`,
    requireAuthentication: true,
  }),

  useCreateFaq: createUseApi<Faq, void>({
    method: "POST",
    url: `${config.public.url}/blog/faq`,
    dataBuilder: (inputData) => omit(inputData, "id"),
    requireAuthentication: true,
  }),

  useGetOneFaq: createUseApi<string, Faq>({
    method: "GET",
    url: (input) => `${config.public.url}/blog/faq/${input}`,
    requireAuthentication: true,
  }),

  useUpdateFaq: createUseApi<Faq, void>({
    method: "PATCH",
    url: (input) => `${config.public.url}/blog/faq/${input.id}`,
    dataBuilder: (inputData) => inputData,
    requireAuthentication: true,
  }),

  useDeleteFaq: createUseApi<string, void>({
    method: "DELETE",
    url: (input) => `${config.public.url}/blog/faq/${input}`,
    requireAuthentication: true,
  }),

  useCreateLink: createUseApi<Link, void>({
    method: "POST",
    url: `${config.public.url}/blog/links`,
    dataBuilder: (inputData) => omit(inputData, "id"),
    requireAuthentication: true,
  }),

  useUpdateLink: createUseApi<Link, void>({
    method: "PATCH",
    url: (inputData) => `${config.public.url}/blog/links/${inputData.id}`,
    dataBuilder: (inputData) => inputData,
    requireAuthentication: true,
  }),

  useGetOneLink: createUseApi<string, Link>({
    method: "GET",
    url: (input) => `${config.public.url}/blog/links/${input}`,
    requireAuthentication: true,
  }),

  useDeleteLink: createUseApi<string, void>({
    method: "DELETE",
    url: (inputData) => `${config.public.url}/blog/links/${inputData}`,
    requireAuthentication: true,
  }),

  useGetFiles: createUseApi<string, File[]>({
    method: "GET",
    url: `${config.public.url}/blog/files`,
    queryBuilder(inputData) {
      return {
        locale: inputData === "uk" ? "ua" : inputData,
      };
    },
  }),

  useGetFile: createUseApi<string, File>({
    method: "GET",
    url: (inputData) => `${config.public.url}/blog/files/${inputData}`,
  }),

  useDeleteFile: createUseApi<string, void>({
    method: "DELETE",
    url: (inputData) => `${config.public.url}/blog/files/${inputData}`,
    requireAuthentication: true,
  }),
};
